import { Modal } from 'antd';
import { Trans } from 'react-i18next';


import { ModalWidthSmall } from '../../../constants/ui';
import { MoreMenu } from '../../PageLayout/index.jsx';
import MoreMenuItem from '../../PageLayout/MoreMenuItem.jsx';
import { Icon as CroplerIcon } from '@cropler/ui-kit';
const PickIcon = (props) => <CroplerIcon name="pinOnMap" {...props} />;
const BorderIcon = (props) => <CroplerIcon name="border" {...props} />;

const AddSeasonMenuModal = ({ t, fieldName, modalOpen = false, closeModal, onPickMap, onCreateManually }) => {
  const trans = <Trans i18nKey={'fields.menu.title'} values={{ fieldName }} />;
  return (
    <Modal
      title={trans}
      open={modalOpen}
      onCancel={closeModal}
      footer={false}
      centered
      width={ModalWidthSmall}
    >
      <MoreMenu>
        <MoreMenuItem onClickButton={onPickMap} text={t('fields.menu.pickOnMap')} Icon={PickIcon} />
        <MoreMenuItem onClickButton={onCreateManually} text={t('fields.menu.createManually')} Icon={BorderIcon} />
      </MoreMenu>
    </Modal>
  );
};

export default AddSeasonMenuModal;
